module.exports = __webpack_public_path__ + "img/40_38_037_320.d16123ca.jpg";